import { Injectable } from '@angular/core';
import { BaseService } from './base-service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PageDTO } from '../model/page-dto';
import { Router } from '@angular/router';
import { UserDTO } from '../model/user-dto';

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseService {
  constructor(http: HttpClient, router: Router) {
    super(http, router);
  }

  getUsers(): Promise<PageDTO<UserDTO>> {
    let parameters = new HttpParams().set('pageNumber', 1).set('pageSize', 999);

    let request = this.get<PageDTO<UserDTO>>('users', parameters);
    return this.apiCall<PageDTO<UserDTO>>(request);
  }

  createUser(user: UserDTO): Promise<void> {
    const request = this.post<void>('users', user);
    return this.apiCall<void>(request);
  }

  updateUser(user: UserDTO): Promise<void> {
    const request = this.put<void>('users', user);
    return this.apiCall<void>(request);
  }

  deleteUser(id: number): Promise<void> {
    const request = this.delete<void>(`users/${id}`);
    return this.apiCall<void>(request);
  }
}
